import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { mapRiskFromData } from "mappers";
import { merchantRiskService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useGetMerchantRiskQuery = (merchantId: string) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["getMerchantRiskData", merchantId],
		() => merchantRiskService.getMerchantRiskData(merchantId),
		{
			select(data: { [key: string]: any }) {
				return mapRiskFromData(data);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!merchantId,
		},
	);

	return queryResult;
};

export default useGetMerchantRiskQuery;
